<div></div>
<div class="container">
    <app-navbar class="sticky-top"></app-navbar>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
</div>